<template>
	<div class="card-v2">
		<template v-if="token && !done">
			<BaseForm class="reset-password-form" v-bind="forward" @submit="save">
				<PasswordField v-model="password" hint="new" required>New Password</PasswordField>
			</BaseForm>
		</template>
		<template v-else-if="done">
		<SuccessMessage>
			<p>Your password was changed successfully!</p>
		</SuccessMessage>
		<p>
			You can now <router-link :to="{ name: $routes.Login.name }">log in</router-link> with your
			new password.
		</p>
		</template>
		<template v-else>
		<div class="error-message">
			<p>The password reset token is missing or invalid.</p>
		</div>
		<p>To reset your password, please follow the link in the email we sent you.</p>
		<p>
			If you don't have this email (or need us to send you another one), you can request one on
			the
			<router-link :to="{ name: $routes.ForgotPassword.name }">forgot password page</router-link>.
		</p>
		<p class="splash-footer">
			<IconLink :to="{ name: $routes.Login.name }" icon="arrow-left">Back to Login</IconLink>
		</p>
		</template>
	</div>
</template>

<script>
import form from '@/mixins/form';

export default {
  name: 'ResetPassword',
  mixins: [form],
  props: {
    verb: {
      type: String,
      default: 'Reset Password',
    },
  },
  data() {
    return {
      done: false,
      password: '',
    };
  },
  computed: {
    token() {
      return this.$route.query.resetPasswordToken;
    },
  },
  methods: {
    save() {
      const token = this.token;
      if (!token || this.done) {
        return;
      }

      /** @type {ResetPasswordDto} */
      const payload = {
        password: this.password,
        resetPasswordToken: token,
      };

      this.action('auth/resetPassword', payload).then(() => {
        this.done = true;
      });
    },
  },
  metaInfo: {
    title: 'Reset Password',
  },
};
</script>
